import range from 'lodash/range';

/* https://stackoverflow.com/a/2868735/780262 */
export function getBalancedGrid(
  numItems: number,
  maxRow: number
): Array<number> {
  const lines = Math.ceil(numItems / maxRow);
  let partition = [].slice.apply(new Uint8Array(lines));
  range(numItems).map((i) => (partition[i % lines] += 1));
  return partition;
}
export function getDifference<T>(listA: Array<T>, listB: Array<T>): Array<T> {
  let difference = new Set(listA);
  let setB = new Set(listB);

  setB.forEach((elem) => {
    difference.delete(elem);
  });

  return Array.from(difference);
}
